import React, { useState, useEffect } from "react";
import arrowUp from "../assets/arrow-up.png";
import ambientTemp from "../assets/ambientTemp.png";
import arrowDown from "../assets/arrow-down.png";
import Clock from "../assets/clock-icon.png";
import action from "../assets/action.png";
import prodTemp from "../assets/productTemp.png";
import back from "../assets/back.png";
import "../styles/selectProgram.css";
import '../styles/basicLayout.css'
import { useHistory, useParams } from "react-router-dom";
import ProductTemp from "../components/ProductTemp";
import Setter from "../components/Setter";
import { saveRecipe, getRecipe } from "../api";
import { MIN_GRILL_TEMP_F, MIN_PROD_TEMP_F, MIN_TIME_S, TERMS } from "../utils/constants";
import CategorySelector from "../components/CategorySelector";
import Stages from '../components/Stages'
import SetActionReq from '../dialog/SetActionReq'

export const settings = {
  PRODUCT_TEMP: "PRODUCT_TEMP",
  GRILL_TEMP: "GRILL_TEMP",
  TIME: "TIME",
  ACTION: "ACTION"
}

function delay(time) {
  return new Promise(resolve => setTimeout(resolve, time));
}

const isAValidStage = (stage) => {
  const { product_temperature_f, grill_temperature_f, time_s, action } = { ...stage }
  if (typeof product_temperature_f !== 'undefined' && typeof grill_temperature_f !== 'undefined')
    return true
  else if (typeof grill_temperature_f !== 'undefined' && typeof time_s !== 'undefined')
    return true
  else if (typeof action !== 'undefined')
    return true
  else
    return false
}

const isValidRecipe = (recipe) => {
  let valid = true
  recipe.stages.forEach(stage => {
    if (!isAValidStage(stage))
      valid = false
  })
  return valid
}

export function ProgramMode() {
  let history = useHistory();
  const [stageEnabled, setStageEnabled] = useState(true)
  const { id } = useParams();
  const [activeStage, setActiveStage] = useState(0)
  const [visibleDialog, setVisibleDialog] = useState(false)
  const [setting, setSetting] = useState(settings.PRODUCT_TEMP)
  const [recipe, setRecipe] = useState({
    name: 'New recipe',
    stages: [
      {
        id: 0,
      }
    ],
    category: null,
    cooking_term: null,
  })

  const handleNextStage = async () => {
    setStageEnabled(false)
    setTimeout(() => {
      setStageEnabled(true)
    }, 1000)
    if (isAValidStage(recipe.stages[activeStage])) {
      if (recipe.stages.length > activeStage + 1) {
        setActiveStage(activeStage + 1)
      }
      else {
        const stages = [...recipe.stages];
        const nRecipe = { ...recipe }
        console.log({ prevStag: stages });
        stages.push({
          id: stages.length,
        })
        nRecipe.stages = stages
        console.log({ currStag: stages, nRecipe });
        setRecipe(nRecipe)
        setActiveStage(activeStage + 1)
      }
    }
    else {
      alert(`Please make sure the parameters are set correctly on this stage before continuing.`)
    }
  }

  const handleSetStage = newStage => {
    console.log('something fishy');
    if (stageEnabled) {
      const stages = [...recipe.stages]
      stages[activeStage] = newStage
      setRecipe({ ...recipe, stages })
    }

  }

  const handleSave = async () => {
    if (isValidRecipe(recipe)) {
      const resp = await saveRecipe(recipe)
      if (resp?.code === 1) {
        alert(`There was an error while saving the recipe, please try again later.`)
      }
      else {
        alert(`Succesfully saved recipe.`)
      }
    }
    else {
      alert(`Please validate the recipe's stages before saving it.`)
    }
  }

  const handleSetCategory = (category) => {
    setRecipe({ ...recipe, category })
  }

  const requestRecipe = async (id) => {
    const resp = await getRecipe({ id })
    setRecipe({
      ...resp.data,
    })
  }

  useEffect(() => {
    if (typeof id !== 'undefined') {
      requestRecipe(id)
    }
  }, [])

  // useEffect( () => {
  //   console.log({recipe});
  // }, [recipe])

  const stage = { ...recipe.stages[activeStage] }
  console.log({ stage });

  return (
    <>
      <SetActionReq
        visible={visibleDialog}
        title={"Action Required"}
        handleClose={() => setVisibleDialog(false)}
        stage={recipe.stages[activeStage]}
        setStage={handleSetStage}
      />
      <header>
        <div className="left">
          <img
            onClick={() => {
              history.goBack();
            }}
            className="btn"
            width="80px"
            src={back} alt="" />
          <h3 style={{ marginLeft: 10 }}>Click Dial</h3>
        </div>
        <div className="center" style={{ display: 'flex', flexDirection: 'column' }}>
          <p className="title">Program Mode</p>
          <input className="title" value={recipe.name} onChange={e => setRecipe({ ...recipe, name: e.target.value })} />
        </div>
        <div className="right">
          <img
            onClick={() => {
              setVisibleDialog(true)
              setSetting(settings.ACTION)
            }}
            className="btn"
            width="80px"
            style={{ borderRadius: 20, padding: 10 }}
            src={action}
          />
          <img
            onClick={() => setSetting(settings.PRODUCT_TEMP)}
            className="btn"
            width="80px"
            style={{ borderRadius: 20, padding: 10 }}
            src={prodTemp}
          />
          <img
            onClick={() => setSetting(settings.TIME)}
            className="btn"
            width="80px"
            style={{ borderRadius: 20, padding: 10 }}
            src={Clock}
          />
          <img
            onClick={() => setSetting(settings.GRILL_TEMP)}
            className="btn"
            width="60px"
            style={{ borderRadius: 20, padding: 10 }}
            src={ambientTemp}
          />
        </div>
      </header>
      <article>
        <div className="left" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
          <button onClick={handleSave} style={{ width: '100%', fontSize: '25px' }}>Save</button>
          <Stages recipe={recipe} activeStage={activeStage} />
        </div>
        <div className="center">
          {(recipe.category !== null && recipe.cooking_term !== null) ?
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
              overflow: 'auto',
              height: '100%'
            }}>
              {(recipe.stages.length > 1 && activeStage >= 1) &&
                <img
                  onClick={async () => {
                    setActiveStage(activeStage - 1)
                    setStageEnabled(false)
                    setTimeout(() => {
                      setStageEnabled(true)
                    }, 1000)
                  }}
                  style={{
                    margin: 10,
                    flex: 0.05,
                  }}
                  width="70px"
                  src={arrowUp}
                  alt=""
                />
              }
              <div style={{ flex: 0.6, width: '100%' }}>
                {stage?.action ?
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <img
                      width="120px"
                      style={{ borderRadius: 20, padding: 10 }}
                      src={action}
                    />
                    <h2>{stage?.action}</h2>
                  </div>
                  :
                  <ProductTemp setting={setting} stage={recipe.stages[activeStage]} />
                }
              </div>
              <img
                onClick={handleNextStage}
                style={{
                  margin: 10,
                  flex: 0.05,
                }}
                width="70px"
                src={arrowDown}
                alt=""
              />
            </div>
            :
            <CategorySelector handleSetCategory={handleSetCategory} category={recipe.category} />
          }
        </div>
        <div className="right" style={{ ...(recipe.cooking_term === null && { alignItems: 'flex-start' }) }}>
          {recipe.cooking_term !== null ?
            <Setter setting={setting} stage={recipe.stages[activeStage]} setStage={handleSetStage} category={recipe.category} />
            // <span>setter</span>
            :
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                alignContent: 'flex-start'
              }}
            >
              <div className="term" onClick={() => setRecipe({ ...recipe, cooking_term: TERMS.RAW })} >Raw</div>
              <div className="term" onClick={() => setRecipe({ ...recipe, cooking_term: TERMS.RARE })}>Rare</div>
              <div className="term" onClick={() => setRecipe({ ...recipe, cooking_term: TERMS.MEDIUM_RARE })}>Medium Rare</div>
              <div className="term" onClick={() => setRecipe({ ...recipe, cooking_term: TERMS.MEDIUM })}>Medium</div>
              <div className="term" onClick={() => setRecipe({ ...recipe, cooking_term: TERMS.MED_WELL })}>Med Well</div>
              <div className="term" onClick={() => setRecipe({ ...recipe, cooking_term: TERMS.WELL_DONE })}>Well Done</div>
            </div>
          }
        </div>
      </article>
    </>
  )
}

export default ProgramMode;